// REACT
import React, { Component } from "react";

// TRANSLATE
import { translate } from "react-i18next";

// AXIOS
import axios from "axios";

// SETTINGS
import Settings from "../../shared/settings";

// STYLES
import styled from "styled-components";

// COMPONENTS
import Loading from "../../components/loading/loading.component";
import Notes from "../../components/notes/notes.component";

// CONTAINERS
import Banner from "../../containers/Banner/banner.container";
import About from "../../containers/About/about.container";
import MainDishes from "../../containers/MainDishes/mainDishes.container";

class DetailsRestaurants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 0,
      data: {},
      dataToBanner: {},
      dataToAbout: {},
      dataToMainDishes: {},
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentWillUpdate() {
    const slug = this.props.match.params.slug;
    const requestLang = window.location.pathname.split("/");
    let lang = requestLang[1];

    if (lang !== this.props.i18n.language) {
      let url =
        "/" +
        this.props.i18n.language +
        "/" +
        this.props.t("restaurantes") +
        "/" +
        slug;
      this.props.history.replace(url, true);
    }
  }

  loadData() {
    const { i18n } = this.props;

    const slug = this.props.match.params.slug;
    let url =
      Settings.server +
      "/api/v1/restaurant/" +
      slug +
      "?expand=menus,timetables,media&lang=" +
      i18n.language;
    axios
      .get(url)
      .then((res) => {
        this.setState({
          data: res.data,
          dataToBanner: {
            banner: res.data.media[1][0],
            restaurantLogo: res.data.media[3][0],
            facebook: res.data.social_networks ? res.data.social_networks.facebook : "",
            instagram: res.data.social_networks ? res.data.social_networks.instagram : "",
            twitter: res.data.social_networks ? res.data.social_networks.twitter : "",
            name: res.data.name ? res.data.name : "",
            description: res.data.description ? res.data.description : "",
            contact: res.data.contact ? res.data.contact : "",
            email: res.data.email ? res.data.email : "",
            time: res.data.timetables ? res.data.timetables : "",
            website: res.data.website ? res.data.website : "",
            network: res.data.network ? res.data.network : "",
            typology: res.data.typology[0] ? res.data.typology[0] : ""
          },

          dataToAbout: {
            about: res.data.about ? res.data.about : null,
            price: res.data.price ? res.data.price : null,
            capacity: res.data.capacity ? res.data.capacity : null,
            notes: res.data.nones ? res.data.nones : null,
            coordinates: {
              lat: res.data.coordinates.lat
                ? Number(res.data.coordinates.lat)
                : null,
              lng: res.data.coordinates.lon
                ? Number(res.data.coordinates.lon)
                : null,
            },
            address: res.data.address ? res.data.address : null,
            media: res.data.media[2] ? res.data.media[2] : null,
          },

          dataToMainDishes: {
            menus: res.data.menus,
            quote: res.data.quote,
            menusCover: res.data.media[10],
            currency: res.data.currency,
          },
          status: 1,
        });
      })
      .catch((err) => {
        this.setState(
          {
            status: 2,
          },
          () => {
            let path = this.props.match.path;
            let url = path.replace("/:slug", "");
            this.props.history.push(url + "/404", url);
          }
        );
      });
  }

  render() {
    const { status, dataToBanner, dataToAbout, dataToMainDishes } = this.state;

    const { t } = this.props;

    return (
      <DetailsPage>
        {status === 0 && (
          <SectionLoading>
            <Loading />
          </SectionLoading>
        )}
        {status === 1 && (
          <DetailsMaster>
            <Banner type="0" t={t} data={dataToBanner} />
            <DetailsContent>
              <About type="0" t={t} data={dataToAbout} />
              {dataToMainDishes.menus.length > 1 && (
                <MainDishes t={t} data={dataToMainDishes} />
              )}
              <Notes type="restaurant_details" t={t} />
            </DetailsContent>
          </DetailsMaster>
        )}
      </DetailsPage>
    );
  }
}

export default translate("translations")(DetailsRestaurants);

// STYLES PAGE
const SectionLoading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  z-index: 1000000000;
  display: flex;
  align-items: center;
`;
const DetailsPage = styled.div``;
const DetailsMaster = styled.div``;
const DetailsContent = styled.div`
  padding-top: 70px;
`;



// WEBPACK FOOTER //
// ./src/pages/detailsRestaurants/detailsRestaurants.page.js